





































































































































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import NewsList from "@/components/NewsList.vue";
import ProgramingStartSection from "@/components/ProgramingStartSection.vue";
import Footer from "@/components/Footer.vue";
import VueRouter, { NavigationGuardNext } from "vue-router";

Component.registerHooks(["beforeRouteLeave"]);

@Component({
  components: {
    Header,
    NewsList,
    ProgramingStartSection,
    Footer,
  },
})
export default class Top extends Vue {
  private headerElement = this.$refs.hero as Element;

  private headerSticky = false;

  @Ref()
  header!: Header;

  private mounted() {
    this.getScroll();
  }

  private async beforeRouteLeave(to: VueRouter, from: VueRouter, next: NavigationGuardNext) {
    await window.removeEventListener("scroll", this.scroll);
    next();
  }

  private getScroll() {
    window.addEventListener("scroll", this.scroll);
  }

  private scroll() {
    const heroHeight = (this.$refs.hero as Element).clientHeight;
    if (window.scrollY > heroHeight) {
      this.headerSticky = true;
    } else {
      this.headerSticky = false;
    }
  }

  @Watch("headerSticky")
  changeClass() {
    this.header.setClass();
  }
}
